











































































































































/* 共通 */
import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
/* ストア、定数関連 */
import { organizationModule } from '../store/modules/Organization'; // 組織管理モジュール
import { supervisingModule } from '../../store/modules/OperationSupervising'; // 画面統括モジュール
import { routingControlModule } from '../../store/modules/RoutingControl'; // ルーティング制御モジュール
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
import { IOrg, ITree } from '../store/dto/Organization'; // dto
/* その他部品 */
import organizationTree from '../components/OrganizationTree.vue'; // ツリーの呼び出し
import TemporarySave from '../../CommonUtils/components/TemporarySave.vue'; // ファイル一時保存機能の呼び出し
import { KanriConstants } from '../fixed/KanriConstants';

// コンポーネント登録
Vue.component('organizationTree', organizationTree);
Vue.component('ApiAccessBase', ApiAccessBase);
Vue.component('TemporarySave', TemporarySave);

@Component
export default class OrganizationInfo extends ApiAccessBase {
  private treeKey = 0;
  private treeValue: ITree = {
    szkCd: '',
    naibCd: '',
    level: '',
    position: '',
  };

  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.screenTitle = '組織登録';
    let path = '';
    routingControlModule.registCurrent(this.$route.name);
    if (organizationModule.CHECK_MOVE_STATE) {
      // 編集時
      path = KanriConstants.ORG_PATH + organizationModule.GET_PATH;
      // organizationModule.arrivalToInfo();
    } else {
      // 新規登録時
      path = KanriConstants.ORG_PATH + '/init/info';
    }
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['organization_info']);
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false).then(
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {
        }
      },
    );
  }
  /**
   * ツリー情報の監視
   * deep: true(ネストされたプロパティも監視する)
   */
  @Watch('treeValue', { deep: true })
  private updateTreeValue(newValue: ITree, oldValue: ITree) {
    if (!supervisingModule.CHECK_MODE_UPDATE) {
        this.formData['parentSzkCd'] = newValue.szkCd;
        this.formData['parentNaibCd'] = newValue.naibCd;
        this.formData['level'] = newValue.level;
    }
  }

  /**
   * 組織情報登録
   * (登録ボタン押下時に発火)
   */
  private registOrg() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      const errorBag: any = this.getFormErrorData(this.$refs.form);
      for (const error of Object.keys(errorBag)) {
        if (errorBag[error]) {
          if (!this.focusElement('input-' + error) ) {
            // ラジオボタン用(エラーidのオブジェクトがdivになっておりradioは+1)
            this.focusElement('input-' + (Number(error) + 1));
          }
          break;
        }
      }
      return;
    }
    if (window.confirm(Message.I0003)) {
      this.apiAccess(
        organizationModule.GET_REGIST_PATH,
        Constants.API_METHOD_POST,
        true,
        false,
      ).then((result) => {
        this.hrefElement('organizationInfo', -50);
        if (result === Constants.API_RESULT_SUCCES) {
          if (!organizationModule.CHECK_MOVE_STATE) {
            const szk: IOrg = {szkCd: this.formData.szkCd, naibCd: this.formData.naibCd, kanriNo: this.formData.kanriNo};
            organizationModule.setOrg(szk);
          }
          this.treeKey = this.treeKey ? 0 : 1;
        } else {
        }
      });
    }
  }

  /**
   * 「戻る」イベント
   * 遷移元の画面に戻る
   */
  private returnPrevious() {

    if (supervisingModule.CHECK_MODE_UPDATE) {
      this.apiAccess(KanriConstants.ORG_PATH + organizationModule.GET_EXCLUSIVE_DELETE_PATH, Constants.API_METHOD_POST, false, true)
      .then((result) => {
        if (result === Constants.API_RESULT_SUCCES) {
          // router.push(routingControlModule.GET_PREVIOUS);
          this.back();
        }
      });
    } else {
      // router.push(routingControlModule.GET_PREVIOUS);
      this.back();
    }
  }
  private back() {
    if (organizationModule.CHECK_MOVE_STATE) {
      organizationModule.moduleSelectReset();
      router.push({ name: 'organizationSearch' });
    } else {
      organizationModule.moduleSelectReset();
      router.push({ name: 'organizationMenu' });
    }
  }
}
